<template>
  <div>
    <base-table-header
      outlined-button
      :options="{ header: 'py-2' }"
      :search-input="false"
      :btn-add="false"
      :btn-download="false"
      :btn-reload="false"
    >
      <template v-slot:subtitle>
        <div class="body-1 black--text">
          Jumlah Data <span class="blue--text font-weight-medium">{{ narasumbers.length }}</span>
        </div>
      </template>
      <template v-slot:toolbarAfter>
        <v-btn
          v-if="$allow('psp-pelatihan-imbas-kelas.save-narasumber')"
          color="primary"
          class="ml-2"
          depressed
          @click="onEdit"
        >
          <v-icon left dark class="mr-1">
            {{ narasumbers.length ? 'mdi-pencil' : 'mdi-plus' }}
          </v-icon>
          {{ narasumbers.length ? 'Ubah' : 'Tambah' }}
        </v-btn>
      </template>
    </base-table-header>
    <v-divider />
    <base-list-table
      :hideHeader="true"
      :loading="false"
      :item="narasumbers"
      :total="narasumbers.length"
      :usePaging="false"
      :emptyMsg="`Anda tidak memiliki data narasumber kelas pelatihan pengimbasan`"
    >
      <template slot-scope="{ item }">
        <td>
          <v-list>
            <v-list-item class="px-0">
              <v-list-item-avatar color="blue">
                <v-icon dark>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-row no-gutters>
                  <v-col cols="12" md="5">
                    <div class="text-body-1 font-weight-medium">{{ $getDeepObj(item, 'akun.nama') }}</div>
                    <div class="text-body-2">
                      SIMPKB ID: <span class="font-weight-medium">{{ $getDeepObj(item, 'akun_id') }}</span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-label color="caption"><small>Email</small></v-label>
                    <div class="text-body-1">
                      {{ $getDeepObj(item, 'akun.email') }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="mt-1">
                      <v-chip :color="+item.k_pelatihan_peserta_psp === 2 ? 'green' : 'orange'" dark>
                        {{ +item.k_pelatihan_peserta_psp === 2 ? 'Narasumber Utama' : 'Narasumber Bantu' }}
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </td>
      </template>
    </base-list-table>
    <base-modal-full ref="modal" :title="formulir.title" @save="onSave">
      <form-narasumber ref="formulir" :initValue="formulir.init" :kandidats="formulir.kandidat" />
    </base-modal-full>
  </div>
</template>

<script>
import BaseTableHeader from '@components/base/BaseTableHeader.vue';
import BaseListTable from '@components/base/BaseListTable.vue';
import FormNarasumber from '../form/Narasumber.vue';
import { mapActions } from 'vuex';

export default {
  name: 'NarasumberDetail',
  components: { BaseListTable, BaseTableHeader, FormNarasumber },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formulir: {},
    };
  },
  computed: {
    narasumbers() {
      return (this.$getDeepObj(this.detail, 'psp_pelatihan_kelas_pesertas') || []).filter((item) =>
        [2, 3].includes(+item.k_pelatihan_peserta_psp)
      );
    },
  },
  methods: {
    ...mapActions('pengimbasanKelas', ['candidate', 'action']),

    async onEdit() {
      const kandidat = await this.candidate({ endpoint: 'narasumber', id: this.detail.psp_pelatihan_kelas_id });

      this.$set(this.formulir, 'title', this.narasumbers.length ? 'Tambah Narasumber Kelas' : 'Ubah Narasumber Kelas');
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'kandidat', kandidat);
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', this.narasumbers);
      });
    },

    onSave() {
      const values = this.$refs.formulir.getValue();

      if (!values.filter((item) => +item.k_pelatihan_peserta_psp === 2).length) {
        this.$error('Narasumber Utama wajib diisi');
        this.$refs.modal.loading = false;
        return;
      }

      if (values.length > 1 && values[0]['akun_id'] === values[1]['akun_id']) {
        this.$error('Narasumber Utama dan Narasumber Bantu tidak boleh oleh orang yang sama');
        this.$refs.modal.loading = false;
        return;
      }

      this.action({ endpoint: 'save-narasumber', id: this.detail.psp_pelatihan_kelas_id, params: { peserta: values } })
        .then(() => {
          this.$success('Data narasumber berhasil disimpan');
          this.$refs.modal.close();
          this.$emit('reload');
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
